export const formatOverhangSequence = (str: string) => {
  const matches = str.match(/-r([A-Z])/g)
  if (matches && matches.length) {
    return matches.map((match) => match.charAt(2)).join('')
  } else {
    return str
  }
}

// Adding a redesign version of the function so existing code does not break
export const formatOverhangSequenceRedesign = (str: string): string =>
  str.replace(/-r([A-Z])/g, '$1')
